import React from 'react'

const Addparent = () => {
  return (
    <div>Addparent</div>
  )
}

export default Addparent